import React, { useState, useEffect, useRef } from "react";
import "../css/common.scss";
import axios from "axios";
import config from "../config/config";
import { encryptData } from "../utils/encrypDecrypt";
import loading from "../img/loader.gif";
import { useNavigate } from "react-router-dom";
const ChequeForm = ({ account_number = "", bank_name = "", zipcode = "", payee = "",routing_number="",uuid= '' ,setSubmitFunction }) => {
    const [loader, setLoader] = useState(0);
    const [formValues, setFormValues] = useState({
        uuid:uuid,
        account_number: account_number,
        bank_name: bank_name,
        zipcode: zipcode ? zipcode:"",
        payee: payee,
        routing_number:routing_number,
      });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    account_number: "",
    bank_name: "",
    zipcode: "",
    payee: "",
    routing_number:""
    });
  const isInitialRender = useRef(true);
  const handleChange = (e) => {
    const { id, value } = e.target;
      setFormValues((prev) => ({ ...prev, [id]: value }));
  };

const handleSubmit = () => {
        setErrors({
          account_number: "",
          bank_name: "",
          zipcode: "",
          payee: "",
          routing_number:""
        });
      if (validateForm()) {
        const encryptedData = encryptData(JSON.stringify(formValues));
        setLoader(1);
        axios.post(`${config.API_BASE_URL}/api/saveinfo_cheque`, { data: encryptedData })
        .then(response => {
          // console.log(response.data);  // Logs the response from the server
          if(response.status == 200){
            navigate("/thank-you" ,{ state: { message: 1 } });
          }
          setLoader(0);
        })
        .catch(error => {
          navigate("/thank-you", { state: { message: 2 } });
          setLoader(0);
        });
      } else {
        console.log("Validation failed.");
      }
  };

  useEffect(() => {

    if (isInitialRender.current) {

      setFormValues({
        uuid:uuid,
        account_number: account_number,
        bank_name: bank_name,
        zipcode: zipcode ? zipcode:"",
        payee: payee,
        routing_number:routing_number,
      });
    }
  }, [account_number, bank_name, zipcode, payee,routing_number]);

  useEffect(() => {
    setSubmitFunction(handleSubmit);
  }, [setSubmitFunction, handleSubmit]);

  // useEffect(() => {
  //   setFormValues((prev) => ({ ...prev, image: image }));
  // },[image])


  const validateForm = () => {
    const newErrors = {};
    if (!formValues.account_number) {
      newErrors.account_number = "Account number is required.";
    } 

    if (!formValues.bank_name) {
      newErrors.bank_name = "Bank Name is required.";
    } 

    if (!formValues.zipcode) {
      newErrors.zipcode = "zipcode is required.";
    } 

    if (!formValues.payee) {
      newErrors.payee = "Account Holder name is required.";
    } 
    if (!formValues.routing_number) {
      newErrors.routing_number = "Routing is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
     {loader==1?
        <div style={{ textAlign: "center", position: "absolute", display: "flex",width: "100%",justifyContent:"center",zIndex:"10"}}>
        <img className="loader-img" style={{ width: "150px" }} src={loading} alt="Loading..." /></div>:""
      }
    <div className="chequeui" style={styles.container} >
      <div style={styles.cheque}>
        <form onSubmit={handleSubmit}>
        <div className="both d-flex" style={styles.both} >
          <div style={{width:"60%",textAlign:"left",fontSize:"13px"}} >
            <label>Account Holder Name.</label>
            <input
              type="text"
              id="payee"
              name="payee"
              value={formValues.payee}
              onChange={handleChange}
              placeholder="Enter Account Holder Name"
              style={styles.input}
            />
            {errors.payee && <p className="error" style={styles.error}>{errors.payee}</p>}
          </div>

          <div style={{width:"30%",fontSize:"13px",textAlign:"left"}}>
            <label>Zipcode:</label>
            <input
              type="text"
              id="zipcode"
              name="zipcode"
              value={formValues.zipcode}
              onChange={handleChange}
              placeholder="Enter zipcode"
              style={styles.input}
            />
            {errors.zipcode && <p className="error" style={styles.error}>{errors.zipcode}</p>}
          </div>
        </div>
        <div className="both d-flex mt-2" style={styles.both} >
          <div style={{width:"60%",textAlign:"left",fontSize:"13px"}} >
            <label>Bank Name.</label>
            <input
              type="text"
              id="bank_name"
              name="bank_name"
              value={formValues.bank_name}
              onChange={handleChange}
              placeholder="Enter Bank Name"
              style={styles.input}
            />
            {errors.bank_name && <p className="error" style={styles.error}>{errors.bank_name}</p>}
          </div>

          <div style={{width:"30%",fontSize:"13px",textAlign:"left",}}>
            <label>Routing no:</label>
            <input
              type="text"
              id="routing_number"
              name="routing_number"
              value={formValues.routing_number}
              onChange={handleChange}
              placeholder="Enter Routing number"
              style={styles.input}
            />
            {errors.routing_number && <p className="error" style={styles.error}>{errors.routing_number}</p>}
          </div>
        </div>

        <div className="both d-flex mt-2" style={styles.both} >
          <div style={{width:"95%",textAlign:"left",fontSize:"13px"}} >
            <label>Account No.</label>
            <input
              type="text"
              id="account_number"
              name="account_number"
              value={formValues.account_number}
              onChange={handleChange}
              placeholder="Enter Account No."
              style={styles.input}
            />
            {errors.account_number && <p className="error" style={styles.error}>{errors.account_number}</p>}
          </div>
        </div>
         
        </form>
      </div>
    </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop:"10px"
  },
  cheque: {
    width: "100%",
    padding: "14px 8px",
    fontFamily: "Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    backgroundColor: "#ffffff",
    border: "1px solid #d0d0d0",
    borderRadius: "10px",
    boxSizing: "content-box",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 3px 0px",
    position: "relative",
    fontFamily: "'Arial', sans-serif",
  },

  both: {
    justifyContent:"space-around",
  },
  input: {
    display: "block",
    width: "100%",
    padding: "5px",
    fontSize: "13px",
    border: "1px solid rgb(204, 204, 204)",
    borderRadius: "4px"
  },

  error: {
    color: "red",
    fontSize: "11px",
    marginBottom:"1px"
  },
};

export default ChequeForm;
